<template>
    <dx-data-grid
        :data-source="dataSource"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="true"
        :show-column-lines="true"
        :show-borders="true"
        :width="'100%'"
        :column-min-width="120"
        :word-wrap-enabled="true"
    >
        <dx-load-panel :enabled="true" />
        <dx-scrolling mode="virtual" />
        <dx-sorting mode="single" />

        <dx-column
            caption="Id работы"
            data-field="workId"
            data-type="string"
            :width="40"
        />

        <dx-column
            caption="Рабта или оборудование"
            data-field="kindWorkId"
            data-type="numeric"
            :width="200"
        >
            <dx-lookup
                :data-source="worksList"
                value-expr="id"
                display-expr="name"
            />
        </dx-column>

        <dx-column
            caption="Пункт ТУ по умолчанию"
            data-field="stageId"
            data-type="numeric"
            :width="200"
        >
            <dx-lookup
                :data-source="stagesList"
                value-expr="id"
                display-expr="name"
            />
        </dx-column>

        <dx-column
            caption="Удельная стоимость (руб)"
            data-field="value"
            data-type="number"
            :width="150"
        >
            <dx-format
                type="fixedPoint"
                :precision="2"
            />
        </dx-column>

        <dx-column
            caption="Наименование работы для ТУ"
            data-field="condition"
            data-type="string"
            :min-width="250"
        />

    </dx-data-grid>
</template>

<script>
export default {
    name: 'arki-work-component',
};
</script>

<script setup>
import { defineProps, onBeforeMount, ref } from 'vue';
import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxLoadPanel,
    DxSorting,
    DxFormat,
    DxLookup
} from 'devextreme-vue/data-grid'
import {
    getStagesTechnicalTask,
    getWorksList
} from '@/views/arki/services/arki-character-service';

const { dataSource } = defineProps({
    dataSource: Array
});

const
    worksList = ref([]),
    stagesList = ref([]);

onBeforeMount(async () => {
    worksList.value = await getWorksList();
    stagesList.value = await getStagesTechnicalTask();
});

</script>

<style lang="scss" scoped>

</style>
